export const DEFAULT_EASE = [0.59, 0.02, 0, 0.98];
export const CURSOR_SIZE = 106;
export const MAXIMUM_NUMBER_OF_PAGES_ON_BUILD = 1;
